import "number-flow";
import { continuous } from 'number-flow';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function initGsapNumberflow() {
    function gsapNumberflow(el) {
        el.plugins = [continuous];

        el.from = parseInt(el.dataset.from) || 0;
        el.to = parseInt(el.dataset.to) || 100;
        el.spinTiming = {
            duration: parseInt(el.dataset.duration) || 600,
            easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
        };
        el.numberPrefix = el.dataset.prefix || '';
        el.numberSuffix = el.dataset.suffix || '';
        el.trend = el.dataset.trend || 0;

        el.update(el.dataset.to);
    }

    const numberflowElements = document.querySelectorAll('number-flow');

    numberflowElements.forEach((el) => {
        // set initial value
        el.update(el.dataset.from || 0);

        ScrollTrigger.create({
            trigger: el,
            onEnter: () => gsapNumberflow(el),
            onLeaveBack: () => (el.update( el.dataset.from || 0 )),
            markers: false,
        });
    });
}
